module.exports = __webpack_public_path__ + "resources/img/img_deepfinder_m.c177648daf550dc4bd12791cf80d94c3.png";